import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { ListItem } from "@website/ui/list-item";
import { Popover } from "@website/ui/popover";
import { isChannel } from "@website/utils/channel/helpers";
import { ExperimentSDK } from "@website/utils/experiments/client";
import { numberConvert } from "@website/utils/number-convert";
import { useToggle } from "@website/utils/use-toggle/useToggle";
import { toggleChatBot } from "@website/widget-v2/chat-bot/navigation";
import { trackChatbotIconClicked } from "@website/widget-v2/chat-bot/tracking";
import { useRouter, useSearchParams } from "next/navigation";
export function SupportAgent() {
  const $ = _c(20);
  const router = useRouter();
  const searchParameters = useSearchParams();
  const [supportMenuIsOpen, toggleSupportMenu] = useToggle(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = isChannel(["b2b", "telesale"]);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const channelAllowed = !t0;
  let t1;
  if ($[1] !== router || $[2] !== searchParameters || $[3] !== toggleSupportMenu) {
    t1 = () => {
      const showChatbot = ExperimentSDK.isOn("chatbot_display") && channelAllowed;
      if (!showChatbot) {
        toggleSupportMenu();
        return;
      }
      trackChatbotIconClicked("support_call");
      toggleChatBot(searchParameters, router);
    };
    $[1] = router;
    $[2] = searchParameters;
    $[3] = toggleSupportMenu;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleSupportClick = t1;
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <MaterialIcon name="support_agent" />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== handleSupportClick) {
    t3 = <Button StartIcon={t2} aria-label={"\u0646\u0645\u0627\u06CC\u0634 \u0644\u06CC\u0646\u06A9 \u0647\u0627\u06CC \u067E\u0634\u062A\u06CC\u0628\u0627\u0646\u06CC"} className="!mx-0 max-xl:!hidden" color="neutral" onClick={handleSupportClick} role="button" variant="text">پشتیبانی</Button>;
    $[6] = handleSupportClick;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <MaterialIcon name="support_agent" />;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== handleSupportClick) {
    t5 = <Button EndIcon={t4} className="!mx-0 xl:!hidden" color="neutral" equalDimension={true} onClick={handleSupportClick} variant="text" />;
    $[9] = handleSupportClick;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <MaterialIcon name="support_agent" />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="w-[312px] rounded-lg py-2"><ListItem StartIcon={t6} aria-label={"\u062A\u0645\u0627\u0633 \u0628\u0627 \u067E\u0634\u062A\u06CC\u0628\u0627\u0646\u06CC"} href="tel:+982192000123" role="link" subtitle={<div className="text-end" style={{
        direction: "ltr"
      }}>{numberConvert("+98 21 92000123", {
          locale: "fa"
        })}</div>} title={"\u062A\u0645\u0627\u0633 \u0628\u0627 \u067E\u0634\u062A\u06CC\u0628\u0627\u0646\u06CC"} /></div>;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== supportMenuIsOpen || $[14] !== toggleSupportMenu) {
    t8 = <Popover gap="16px" horizontalPosition="end" onClose={toggleSupportMenu} open={supportMenuIsOpen}>{t7}</Popover>;
    $[13] = supportMenuIsOpen;
    $[14] = toggleSupportMenu;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t3 || $[17] !== t5 || $[18] !== t8) {
    t9 = <div className="relative">{t3}{t5}{t8}</div>;
    $[16] = t3;
    $[17] = t5;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}